<template>
  <div class="container align-items-center justify-content-center d-flex vh-100">
    <div class="w-100" style="max-width: 30rem">
      <div class="d-flex align-items-center justify-content-center mb-5 gap-2 fs-2 fw-bold">
        <Logo :fill="'#4089c9'" :fillRect="'#ffffff'" :height="'42px'" :width="'42px'"></Logo>
        Portal
      </div>
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>
      <div class="card shadow-sm border-light-subtle">
        <div class="card-body p-5">
          <form action="#" @submit.prevent="submit">
            <div class="mb-4">
              <label class="form-label">{{ $t("login.email") }}</label>
              <div class="input-group">
                <span class="input-group-text fw-bold">
                  <font-awesome-icon :icon="['far', 'envelope']" />
                </span>
                <input id="email" type="email" class="form-control" value required autofocus v-model="form.email"
                  :disabled="loading" />
              </div>
            </div>
            <div class="mb-4">
              <label class="form-label">{{ $t("login.password") }}</label>
              <div class="input-group">
                <span class="input-group-text">
                  <font-awesome-icon :icon="['far', 'key']" />
                </span>
                <input id="password" type="password" class="form-control" required v-model="form.password"
                  :disabled="loading" />
              </div>
            </div>
            <div class="mb-3">
              <button type="submit" class="btn btn-primary w-100 text-white" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                  aria-hidden="true"></span>
                {{ $t("login.login") }}
              </button>
            </div>
            <div class="mb-4">
              <button type="button"
                class="btn btn-primary w-100 text-white d-flex align-items-center justify-content-center gap-2"
                :disabled="loadingMicrosoft" @click="signInWithMicrosoft">
                <img src="../assets/microsoft-logo.svg" alt="Microsoft" />
                {{ $t("login.sign_in_with_microsoft") }}
                <span v-if="loadingMicrosoft" class="spinner-border spinner-border-sm" role="status"
                  aria-hidden="true"></span>
              </button>
            </div>
            <div class="text-center">
              <small>
                <router-link class="link-underline link-underline-opacity-0 link-underline-opacity-100-hover"
                  :to="`/password-reset`">
                  {{ $t("login.password_reset") }}
                </router-link>
              </small>
            </div>
          </form>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <Lang />
      </div>
    </div>
  </div>
</template>

<script>
import { signInWithEmailAndPassword, OAuthProvider, signInWithPopup } from "firebase/auth";
import Logo from "../assets/Logo";
import Lang from "./smallComponents/LangComponent";
import { auth, firestore } from "../plugins/firebase";
import { doc, getDoc } from "firebase/firestore";

export default {
  name: "LoginComponent",
  components: {
    Logo,
    Lang,
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      error: null,
      loading: false,
      loadingMicrosoft: false,
    };
  },
  methods: {
    fetchLanguageFromFirestore(user) {
      const docRef = doc(firestore, "userLang", user.uid);
      return getDoc(docRef).then((doc) => {
        if (doc.exists()) {
          const data = doc.data();
          this.$i18n.locale = data.lang || this.$i18n.locale;
          localStorage.setItem("clgmbh-portal-lang", this.$i18n.locale);
        }
      });
    },
    submit() {
      this.loading = true;
      signInWithEmailAndPassword(auth, this.form.email, this.form.password)
        .then(async (userCredential) => {
          await this.fetchLanguageFromFirestore(userCredential.user);
          this.$router.replace({ name: "Home" });
        })
        .catch((err) => {
          this.error =
            this.$t(`firebaseAuthErrors.${err.code}`) || err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Sign in with Microsoft account
    async signInWithMicrosoft() {
      this.loadingMicrosoft = true;
      this.error = null;
      const provider = new OAuthProvider("microsoft.com");
      provider.setCustomParameters({
        prompt: "select_account",
        tenant: process.env.VUE_APP_SETUP_TENANT_ID,
      });
      signInWithPopup(auth, provider)
        .then((userCredential) => {
          this.fetchLanguageFromFirestore(userCredential.user);
          this.$router.replace({ name: "Home" });
        })
        .catch((err) => {
          if (err.code === "auth/account-exists-with-different-credential") {
            this.error = this.$t(`login.account_exists_with_different_credential`);
          } else {
            this.error = this.$t(`firebaseAuthErrors.${err.code}`) || err.message;
          }
        })
        .finally(() => {
          this.loadingMicrosoft = false;
        });
      return;
    }
  },
};
</script>
